<template>
    <li class="col-span-1 flex rounded-md shadow-xs">
        <div :class="['flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white', check_colour_class]">
            <CheckIcon v-if="check.status === 'clear'" class="h-8 w-8 text-white" />
            <ClockStrokeIcon v-else-if="check.status === 'tba'" class="h-8 w-8 text-white" />
            <AlertWarningIcon v-else class="h-8 w-8 text-white" />
        </div>
        <div class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white">
            <div class="flex-1 truncate px-4 py-2 text-sm">
                <h3 v-if="check.status === 'clear'" class="font-medium text-gray-900 hover:text-gray-600">{{ type_label }}: Clear</h3>
                <h3 v-else class="font-medium text-gray-900 hover:text-gray-600">{{ type_label }}: {{ check.label }}</h3>
                <p class="text-gray-500 inline-flex items-center gap-x-3">
                    <span v-if="event_date">Declared {{ event_date }}</span>
                    <svg v-if="event_date" viewBox="0 0 2 2" class="h-[0.2rem] w-[0.2rem] text-gray-400 fill-current">
                        <circle r="1" cx="1" cy="1" />
                    </svg>
                    <span v-if="check_by_name && check.status !== 'tba'">Updated by {{ check_by_name }}</span>
                    <span v-else-if="check.status === 'tba'">Pending HPI Check</span>
                </p>
            </div>
            <div class="shrink-0 pr-2">
                <ButtonConfirm
                    ref="confirm_delete"
                    v-if="check.status !== 'tba'"
                    :trigger_button_color="'text-red'"
                    :trigger_button_width="'w-auto'"
                    :trigger_button_disabled="false"
                    :trigger_button_icon="null"
                    :trigger_button_custom_class="null"
                    :trigger_button_size="'sm'"
                    :trigger_button_text="'Delete'"
                    :confirm_button_color="'red'"
                    :confirm_button_disabled="false"
                    :confirm_button_icon="null"
                    :confirm_button_class="null"
                    :confirm_button_text="'Yes, delete'"
                    :cancel_button_text="'Back'"
                    :no_cancel="false"
                    :buttons_disabled="false"
                    :loading="false"
                    :onConfirm="deleteCheck"
                    :heading="`Delete this check?`"
                    :body="`Are you sure that you want to delete this check?`"
                />
            </div>
        </div>
    </li>
</template>

<script>
import { computed, reactive, ref } from "vue"
import moment from 'moment'
import CONFIG from '@lib/config'
import { useCheckStore } from "@sto/check.store"
import { useSystemStore } from "@sto/system.store"

import CheckIcon from "@ico/CheckIcon.vue";
import AlertErrorIcon from "@ico/AlertErrorIcon.vue"
import AlertWarningIcon from "@ico/AlertWarningIcon.vue"
import ClockStrokeIcon from "@ico/ClockStrokeIcon.vue"
export default {
    props: ['check', 'refresh'],
    components: {
        CheckIcon,
        AlertErrorIcon,
        AlertWarningIcon,
        ClockStrokeIcon
    },
    setup (props) {

        const CHECK_STORE = useCheckStore()
        const SYSTEM_STORE = useSystemStore()

        const confirm_delete = ref()

        const state = reactive({
            loading: false
        })

        const check_by_name = computed(() => `${props.check.user_first_name} ${props.check.user_last_name}`)
        const event_date = computed(() => {
            if (!props.check.event_date) return null
            return moment(props.check.event_date).format(CONFIG.dates.formats.brief_date)
        })

        const check_colour_class = computed(() => {
            switch (props.check.status) {
                case 'tba':
                    return 'bg-gray-300'
                case 'clear':
                    return 'bg-green-500'
                case 'warning':
                case 'alert':
                default:
                    return 'bg-red-500'
            }
        })

        const type_label = computed(() => {
            switch (props.check.type) {
                case 'vehicle:manual_check':
                    return 'HPI Check'
                case 'vehicle:plate_transfers':
                    return 'Plate Transfer'
                case 'vehicle:security_watch':
                    return 'Security Watch'
                case 'vehicle:finance_agreements':
                    return 'Finance Agreements'
                case 'vehicle:insurance_damages':
                    return 'Insurance Damages'
                case 'vehicle:insurance_thefts':
                    return 'Insurance Thefts'
                case 'vehicle:insurance_inspections':
                    return 'Insurance Inspections'
                case 'vehicle:stolen_incidents':
                    return 'Stolen'
            }
        })

        const deleteCheck = async () => {

            if (state.loading) return

            try {
                state.loading = true
                await CHECK_STORE.deleteCheck(props.check.id)
                SYSTEM_STORE.addSuccess('Check deleted')
                confirm_delete.value.closeModal()
                if (props.refresh) props.refresh()

            } catch (error) {
                SYSTEM_STORE.addError('Error', error?.message || 'There was a problem deleting the check')
                console.error('CHECK_STORE.deleteCheck error', error)

            } finally {
                state.loading = false
            }
        }

        return {
            check_by_name,
            type_label,
            event_date,
            check_colour_class,
            confirm_delete,
            deleteCheck
        }
    }
}
</script>